import cn from "@/util/cn";
import { ComponentPropsWithoutRef, ReactNode } from "react";

type ErrorsWidgetProps = {
  errorMessages: string[];
  format: (errorMessage: string) => ReactNode;
} & ComponentPropsWithoutRef<"ul">;

const ErrorsWidget = ({ errorMessages, format, className, ...otherProps }: ErrorsWidgetProps) => (
  <ul
    className={cn(
      "rounded-md border border-red-200 bg-red-100 px-2 py-2",
      errorMessages.length > 1 ? "list-disc ps-6" : "",
      className
    )}
    {...otherProps}
  >
    {errorMessages.map((errorMessage) => (
      <li className="text-red-600" key={errorMessage}>
        {format(errorMessage)}
      </li>
    ))}
  </ul>
);

export default ErrorsWidget;
